import { dia as Dia, shapes } from 'libs/rappid/build/rappid';

shapes.basic.Rect.define('cyberThing.Destination',
	{
		type: 'cyberThing.Destination',
		attrs: {
			rect: {
				stroke: 'none',
				'fill-opacity': 0
			}
		}
	}
);